import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UIGmapMarkersComponent } from "@directives/_map/angularGoogleMaps/uiGmapMarkers.component";
import { UIGmapPolygonComponent } from "@directives/_map/angularGoogleMaps/uiGmapPolygon.component";
import { VeriMapCurrentJourneyComponent } from "@directives/_map/veriMap/veriMapCurrentJourney/veriMapCurrentJourney.component";
import { UIGmapMarkerComponent } from "./angularGoogleMaps/uiGmapMarker.component";
import { UIGmapPolylineComponent } from "./angularGoogleMaps/uiGmapPolyline.component";
import { UIGmapPolylinesComponent } from "./angularGoogleMaps/uiGmapPolylines.component";
import { VMapComponent } from "./v-map/v-map/v-map.component";
import { VeriMapContainerComponentFacade } from "./veriMap/veriMapContainer/veri-map-container.component";
import { VeriMapJourneysNewComponent } from "./veriMap/veriMapJourneysNew/veriMapJourneysNew.component";
import { VeriMapSingleGeofenceComponentFacade } from "./veriMap/veriMapSingleGeofence/v-map-single-geofence.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    UIGmapMarkersComponent,
    UIGmapMarkerComponent,
    UIGmapPolylinesComponent,
    UIGmapPolylineComponent,
    UIGmapPolygonComponent,

    VeriMapCurrentJourneyComponent,
    VeriMapJourneysNewComponent,

    VMapComponent
];

const declarations: any[] = [
    VeriMapSingleGeofenceComponentFacade,
    VeriMapContainerComponentFacade
];

@NgModule({
    imports: [
        CommonModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class MapDirectivesModule {
    constructor() {
    }
}
